'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthBitHeader = require('@narvar/nth-bit-header');
var ClaimsListItemImages = require('./ClaimsListItemImages.js');
var ClaimTypeLabel = require('../../components/ClaimTypeLabel.js');
var SelectableCard = require('../../../../common/components/SelectableCard.js');
var AgentNavigatorProvider = require('../../providers/AgentNavigatorProvider.js');
var PermissionsProvider = require('../../providers/permissions/PermissionsProvider.js');
var ClaimStatusChip = require('../../components/ClaimStatusChip/ClaimStatusChip.js');
var Box = require('../../../../common/components/layout/Box/Box.js');
var useTitanAnalytics = require('../../../../common/providers/titan/useTitanAnalytics.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);

const ClaimsListItem = _ref => {
  let {
    claim
  } = _ref;
  const titan = useTitanAnalytics["default"]();
  const {
    viewClaim: canViewClaim
  } = PermissionsProvider.usePermissions();
  const {
    claimsClaimDetailsLastUpdated
  } = nthHookTranslations.useTranslations();
  const {
    navigateToClaimDetails
  } = AgentNavigatorProvider.useAgentNavigator();
  const {
    captiontextDefaultNone
  } = nthHookTheme.useTheme();
  const {
    id,
    status,
    items,
    updatedOn,
    claimType
  } = claim;
  return /*#__PURE__*/React__default["default"].createElement(SelectableCard["default"], {
    readOnly: !canViewClaim,
    onClick: () => {
      titan === null || titan === void 0 ? void 0 : titan.track({
        event: 'product_clicked',
        properties: {
          product_id: id,
          category: claimType,
          variant: status
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
      navigateToClaimDetails(id);
    }
  }, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    as: "li",
    gap: 2,
    style: {
      alignItems: 'start'
    }
  }, status && /*#__PURE__*/React__default["default"].createElement(ClaimStatusChip["default"], {
    status: status
  }), /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 1
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    as: 'div'
  }, id), claimType && /*#__PURE__*/React__default["default"].createElement(ClaimTypeLabel["default"], {
    claimType: claimType
  }), items && /*#__PURE__*/React__default["default"].createElement(ClaimsListItemImages["default"], {
    claimItems: items,
    listLabelId: `${id}-images`
  }), updatedOn && /*#__PURE__*/React__default["default"].createElement("p", {
    style: {
      margin: 0,
      ...captiontextDefaultNone
    }
  }, mustache__default["default"].render(claimsClaimDetailsLastUpdated ?? '', {
    date: updatedOn
  })))));
};
var ClaimsListItem$1 = nthHookTheme.withThemeProvider(nthHookTranslations.withTranslationsProvider(ClaimsListItem, {
  translationKeys: ['claimsClaimDetailsLastUpdated']
}), {
  themeTokens: ['captiontextDefaultNone']
});

exports["default"] = ClaimsListItem$1;
